/* Bower — Known visitor flag
 *
 * Persists a "the visitor came in from a Sunday email" signal so the
 * homepage can swap the cold-prospect signup form for a warm
 * "Show me this week →" shortcut, and the header can surface a
 * direct nav link to /pages/this-week.
 *
 * Set by:
 *   - URL with `?src=email` (any page) — this is what the merchant's
 *     Sunday emails should point at.
 *   - any visit to `/pages/this-week` — the only intentional entry
 *     to that page is from the email, so landing there is itself
 *     evidence the visitor is on the list.
 *
 * Persisted in `localStorage["bower:from-email"]` (boolean string).
 * Sticky — once set, persists until the user clears site data. Not a
 * security boundary, just a UX hint.
 *
 * Effect: adds `is-bower-known-visitor` to `<body>` whenever the
 * flag is set (including on subsequent unrelated visits). CSS in
 * the hero / header sections gates which UI variants render.
 *
 * The "user is already on the list" detection that the prospect
 * signup form would need (to skip the welcome confirmation) is NOT
 * implemented here — Shopify's customer endpoint can't disambiguate
 * "already subscribed" from generic validation errors. That lands
 * with the Klaviyo / ESP integration step.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'bower:from-email';
  const BODY_CLASS = 'is-bower-known-visitor';

  function isKnown() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  function markKnown() {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      // Storage blocked (private mode, full quota, etc.) — fall back
      // to the body class for the current pageview only.
    }
  }

  function applyBodyClass() {
    if (document.body) document.body.classList.add(BODY_CLASS);
  }

  // Triggers that mark the visitor as known.
  const params = new URLSearchParams(window.location.search);
  if (params.get('src') === 'email') markKnown();
  if (window.location.pathname === '/pages/this-week') markKnown();

  if (isKnown()) {
    if (document.body) {
      applyBodyClass();
    } else {
      document.addEventListener('DOMContentLoaded', applyBodyClass);
    }
  }
})();
